<!-- 线性图表 -->
<template>
  <div class="echarts">
    <div :ref="echartName" :style="'height:'+height"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: 'LineChart',
  components: {},
  props: {
    echartData: {
      type: Object,
      default() {
        return null
      }
    },
    echartName: {
      type: String,
      default: "echarts"
    },
    height: {
      type: String,
      default: "200px"
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      chartOptions: {
        title: {
          show: true,//显示策略，默认值true,可选为：true（显示） | false（隐藏）
          text: this.type === 1 ? '账户支出' : '技术老师',//主标题文本，'\n'指定换行
          subtext: this.type === 1 ? '分析' : '服务',//副标题文本，'\n'指定换行
          x: '34%',//水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          y: '39%',//垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
          textAlign: 'center',//水平对齐方式，默认根据x设置自动调整，可选为： left' | 'right' | 'center
          backgroundColor: 'rgba(0,0,0,0)',//标题背景颜色，默认'rgba(0,0,0,0)'透明
          borderColor: '#fff',//标题边框颜色,默认'#ccc'
          borderWidth: 0,//标题边框线宽，单位px，默认为0（无边框）
          padding: 3,//标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距
          itemGap: 5,//主副标题纵向间隔，单位px，默认为10
          textStyle: {//主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 14,
            color: '#fff',
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
          subtextStyle: {//副标题文本样式{"color": "#aaa"}
            fontSize: 14,
            color: '#fff',
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
          zlevel: 0,//一级层叠控制。默认0,每一个不同的zlevel将产生一个独立的canvas，相同zlevel的组件或图标将在同一个canvas上渲染。zlevel越高越靠顶层，canvas对象增多会消耗更多的内存和性能，并不建议设置过多的zlevel，大部分情况可以通过二级层叠控制z实现层叠控制。
          z: 6,//二级层叠控制，默认6,同一个canvas（相同zlevel）上z越高约靠顶层。
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 2,
          icon: 'circle', // 设置图例标记为圆形
          textStyle: {
            color: '#fff' // 设置图例文字颜色为红色
          },
          data: [],
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['35%', '80%'],
            center: ['35%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'inner', // 文字显示在扇形外侧
              formatter: data => {
                return this.type === 1 ? `${data.percent.toFixed(0)}%\n${data.value}元` : `${data.percent.toFixed(0)}%`
              }
            },
            labelLine: {
              show: false
            },
            data: [],
            
          }
        ]
      },
      echarts: null,
      a: 'ge'
    }
  },
  created() {
  },
  mounted() {
    this.calcEcharts()
  },
  methods: {
    calcEcharts() {
      if (!this.echarts) {
        this.echarts = echarts.init(this.$refs[this.echartName]);
        // 添加窗口改变监听
        this.echarts._resize = () => {
          this.echarts.resize();
        };
        window.addEventListener("resize", this.echarts._resize);
      }
      console.log(this.echartData)
      this.chartOptions.legend.data = this.echartData.legendData;
      this.chartOptions.series[0].data = this.echartData.yAxisData;
      this.refreshChart();
    },
    refreshChart() {
      let myChart = this.echarts;
      if (!this.echarts) {
        myChart = echarts.init(this.$refs.echarts);
      }
      myChart.clear();
      myChart.setOption(this.chartOptions);
      console.log(this.chartOptions)
    }
  },
  watch: {
    echartData(newVal) {
      this.calcEcharts()
    }
  }
}
</script>
<style lang='scss' scoped>
.echarts {
  width: 100%;
}
</style>
